import { TableCell, TableHead, TableRow, Checkbox } from '@mui/material';
import { SelectedSort } from '@/hooks/useSortableData';
import { ColumnConfig } from './Table';
import { SortableRow } from './SortableRow';

const stickyHeaderCellSx = {
  backgroundColor: 'var(--white-color)',
  borderBottom: '1px solid #e5e7eb',
  padding: '14px 16px',
  position: 'sticky' as const,
  top: 0,
  zIndex: 1,
};

interface TableStickyHeaderProps {
  columns: ColumnConfig[];
  isGhost?: boolean;
  selectedSort?: SelectedSort;
  renderActions?: (rowData: Record<string, any>) => React.ReactNode;
  handleSort?: (key: string) => void;
  selectable?: boolean;
  selectedKeys?: Set<string>;
  data?: any[];
  maxSelectable?: number;
  isAllSelected?: boolean;
  onSelectAll?: (checked: boolean) => void;
}

export const TableStickyHeader = ({
  columns,
  renderActions,
  selectedSort,
  handleSort,
  isGhost,
  selectable,
  selectedKeys,
  data = [],
  isAllSelected = false,
  onSelectAll,
}: TableStickyHeaderProps) => (
  <TableHead>
    <TableRow>
      {selectable && (
        <TableCell
          padding='checkbox'
          sx={{
            width: '48px',
            ...(isGhost
              ? {
                  backgroundColor: 'transparent',
                  padding: '14px 16px',
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }
              : stickyHeaderCellSx),
          }}
        >
          <Checkbox
            indeterminate={
              !isAllSelected && selectedKeys && selectedKeys.size > 0
            }
            checked={isAllSelected}
            onChange={(e) => onSelectAll?.(e.target.checked)}
            disabled={data.length === 0}
            sx={{
              color: 'var(--primary-color)',
              '&.Mui-checked': { color: 'var(--primary-color)' },
            }}
          />
        </TableCell>
      )}
      {columns.map((column) => (
        <TableCell
          key={column.field}
          sx={
            isGhost
              ? {
                  cursor: column?.sortable ? 'pointer' : undefined,
                  backgroundColor: 'transparent',
                  padding: '14px 16px',
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }
              : {
                  ...stickyHeaderCellSx,
                  cursor: column?.sortable ? 'pointer' : undefined,
                }
          }
          onClick={() => column?.sortable && handleSort?.(column?.field)}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '4px',
              fontWeight: 600,
              fontSize: '1.125rem',
              lineHeight: 1.35,
              color: isGhost ? 'var(--secondary-color)' : 'var(--primary-color)',
              opacity: isGhost ? 0.5 : 1,
              fontStyle: isGhost ? 'italic' : 'normal',
            }}
          >
            {column.label}
            <SortableRow column={column} selectedSort={selectedSort} />
          </div>
        </TableCell>
      ))}
      {renderActions && (
        <TableCell
          sx={
            isGhost
              ? {
                  backgroundColor: 'transparent',
                  padding: '14px 16px',
                  position: 'sticky',
                  top: 0,
                  zIndex: 1,
                }
              : stickyHeaderCellSx
          }
        />
      )}
    </TableRow>
  </TableHead>
);
